import { mapCollection } from '../../utils/collection.utils';
import { CategoryResultsAverage } from '../category-results-average';

export class CategoryResultsAverageBuilder {
  static fromJson(json) {
    return (json)
      ? new CategoryResultsAverage(
        json.hash,
        json.title,
        json.answerAVG,
        json.thumbnailImage,
        json.thumbnailPrimary,
        json.thumbnailSecondary,
        json.questionsResultsAverage
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(CategoryResultsAverageBuilder.fromJson, list) : [];
  }
}
